"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _colors = require("HubStyleTokens/colors");

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIStepperInput = _interopRequireDefault(require("UIComponents/input/UIStepperInput"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _FieldsetContext = require("UIComponents/context/FieldsetContext");

var _getStepperPropsWithClearedDisabledProp = _interopRequireDefault(require("../utils/getStepperPropsWithClearedDisabledProp"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var i18nKey = function i18nKey(key) {
  return "FileManagerLib.dimensions." + key;
};

var Dimensions = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Dimensions, _Component);

  function Dimensions(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Dimensions);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Dimensions).call(this, props));
    _this.onWidthChange = _this.onWidthChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onHeightChange = _this.onHeightChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onWidthStep = _this.onWidthStep.bind((0, _assertThisInitialized2.default)(_this));
    _this.onHeightStep = _this.onHeightStep.bind((0, _assertThisInitialized2.default)(_this));

    if (props.withResetButton && typeof props.onReset !== 'function') {
      console.warn("Warning: The prop `onReset` should be a valid function when `withResetButton === true`.");
    }

    return _this;
  }

  (0, _createClass2.default)(Dimensions, [{
    key: "getAspectRatio",
    value: function getAspectRatio() {
      var _this$props = this.props,
          naturalWidth = _this$props.naturalWidth,
          naturalHeight = _this$props.naturalHeight;
      var _this$props$dimension = this.props.dimensions,
          width = _this$props$dimension.width,
          height = _this$props$dimension.height;

      if (naturalWidth && naturalHeight) {
        return naturalWidth / naturalHeight;
      }

      return width / height;
    }
  }, {
    key: "calcWidth",
    value: function calcWidth(height) {
      return Math.round(height * this.getAspectRatio());
    }
  }, {
    key: "calcHeight",
    value: function calcHeight(width) {
      return Math.round(width * (1 / this.getAspectRatio()));
    }
  }, {
    key: "onWidthChange",
    value: function onWidthChange(event) {
      var onChange = this.props.onChange;
      var width = Math.floor(event.target.value);

      if (isNaN(width) || width <= 0) {
        return;
      }

      onChange({
        height: this.calcHeight(width),
        width: width
      });
    }
  }, {
    key: "onHeightChange",
    value: function onHeightChange(event) {
      var onChange = this.props.onChange;
      var height = Math.floor(event.target.value);

      if (isNaN(height) || height <= 0) {
        return;
      }

      onChange({
        width: this.calcWidth(height),
        height: height
      });
    }
  }, {
    key: "onWidthStep",
    value: function onWidthStep(event) {
      var onStep = this.props.onStep;
      var width = Math.floor(event.target.value);

      if (typeof onStep !== 'function' || isNaN(width) || width <= 0) {
        return;
      }

      onStep({
        height: this.calcHeight(width),
        width: width
      });
    }
  }, {
    key: "onHeightStep",
    value: function onHeightStep(event) {
      var onStep = this.props.onStep;
      var height = Math.floor(event.target.value);

      if (typeof onStep !== 'function' || isNaN(height) || height <= 0) {
        return;
      }

      onStep({
        width: this.calcWidth(height),
        height: height
      });
    }
  }, {
    key: "getIconPadding",
    value: function getIconPadding(fieldSize) {
      return fieldSize === 'small' ? 'p-bottom-1' : 'p-bottom-2';
    }
  }, {
    key: "renderResetButton",
    value: function renderResetButton() {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          onReset = _this$props2.onReset;
      return _react.default.createElement(_Small.default, null, _react.default.createElement(_UIButton.default, {
        disabled: disabled,
        onClick: onReset,
        use: "link"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('resetLabel')
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          dimensions = _this$props3.dimensions,
          widthStepperProps = _this$props3.widthStepperProps,
          heightStepperProps = _this$props3.heightStepperProps,
          disabled = _this$props3.disabled,
          onReset = _this$props3.onReset,
          withResetButton = _this$props3.withResetButton;
      var width = dimensions.width,
          height = dimensions.height;
      return _react.default.createElement(_FieldsetContext.Consumer, null, function (_ref) {
        var fieldSize = _ref.size;
        return _react.default.createElement(_UIFlex.default, {
          align: "end"
        }, _react.default.createElement(_UIFormControl.default, {
          className: "m-all-0",
          label: (0, _unescapedText.default)(i18nKey('widthLabel'))
        }, _react.default.createElement(_UIStepperInput.default, Object.assign({}, (0, _getStepperPropsWithClearedDisabledProp.default)(widthStepperProps), {
          disabled: disabled,
          stepSize: 1,
          value: width,
          onChange: _this2.onWidthChange,
          onStep: _this2.onWidthStep
        }))), _react.default.createElement(_UIIcon.default, {
          className: "m-x-2 " + _this2.getIconPadding(fieldSize),
          color: _colors.BATTLESHIP,
          name: "link",
          size: "xxs"
        }), _react.default.createElement(_UIFormControl.default, {
          className: "m-all-0",
          help: withResetButton && typeof onReset === 'function' && _this2.renderResetButton(),
          label: (0, _unescapedText.default)(i18nKey('heightLabel'))
        }, _react.default.createElement(_UIStepperInput.default, Object.assign({}, (0, _getStepperPropsWithClearedDisabledProp.default)(heightStepperProps), {
          disabled: disabled,
          stepSize: 1,
          value: height,
          onChange: _this2.onHeightChange,
          onStep: _this2.onHeightStep
        }))));
      });
    }
  }]);
  return Dimensions;
}(_react.Component);

Dimensions.propTypes = {
  dimensions: _propTypes.default.shape({
    width: _propTypes.default.number.isRequired,
    height: _propTypes.default.number.isRequired
  }).isRequired,
  naturalWidth: _propTypes.default.number,
  naturalHeight: _propTypes.default.number,
  onChange: _propTypes.default.func.isRequired,
  onReset: _propTypes.default.func,
  onStep: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  widthStepperProps: _propTypes.default.shape(_UIStepperInput.default.propTypes),
  heightStepperProps: _propTypes.default.shape(_UIStepperInput.default.propTypes),
  withResetButton: _propTypes.default.bool
};
Dimensions.defaultProps = {
  disabled: false
};
var _default = Dimensions;
exports.default = _default;
module.exports = exports.default;